var map = {
	"./Actualizable/Actualizable.sol": 5045,
	"./Actualizable2/Actualizable2.sol": 87617,
	"./Actualizable2/Actualizable2Proxy.sol": 9935,
	"./Actualizable3/Actualizable3.sol": 21853,
	"./Actualizable4/Actualizable4.sol": 91012,
	"./Aleatorio/Aleatorio.sol": 36867,
	"./Bienvenida/Bienvenida.sol": 56794,
	"./Bloqueado/Bloqueado.sol": 91337,
	"./CanjeImposible/CanjeImposible.sol": 77548,
	"./DatosPrivados/DatosPrivados.sol": 20193,
	"./Delegar/Delegar.sol": 70815,
	"./Denegacion/Denegacion.sol": 19803,
	"./Denegacion2/Denegacion2.sol": 38368,
	"./Desbordamiento/Desbordamiento.sol": 48395,
	"./DesdeContrato/DesdeContrato.sol": 96646,
	"./ErrorFatal/ErrorFatal.sol": 18402,
	"./ManipularStorage/ManipularStorage.sol": 3107,
	"./MisionEspacial/MisionEspacial.sol": 27187,
	"./MisionEspacial/MisionEspacialProxy.sol": 28652,
	"./NombreConstructor/NombreConstructor.sol": 39383,
	"./Pesca/Pesca.sol": 86355,
	"./Puntero/Puntero.sol": 46610,
	"./Reentrada/Reentrada.sol": 62006,
	"./Reentrada2/Reentrada2.sol": 75428,
	"./Reentrada3/Reentrada3.sol": 71548,
	"./ReutilizandoValor/ReutilizandoValor.sol": 96066,
	"./SaldoInesperado/SaldoInesperado.sol": 73794,
	"./Token/Token.sol": 94361,
	"./Trampa/Trampa.sol": 57639,
	"./Transferencia/Transferencia.sol": 68230
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43298;